import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SmartMoneyCard from './SmartMoneyCard';


// Importa los estilos de Tailwind
import 'tailwindcss/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SmartMoneyCard />
  </React.StrictMode>
);
